<template>
  <v-container>
    <div class="row">
      <div class="col-4 align-self-center">
        <v-file-input
          :label="$t('views.downloadcenter.icon')"
          v-on:change="handleFileChange"
          v-model="file"
          ref="fileIcon"
          accept=".svg"
        ></v-file-input>
      </div>
      <div class="col-auto align-self-center">
        <!-- <v-checkbox
          v-model="useThemeSettings"
          :label="$t('components.iconuploader.use_theme_colors')"
        ></v-checkbox> -->
        <div class="title">
              {{ $t("globals.color") }}
            </div>
            <v-color-picker
              v-model="color"
              :rules="[$rules.required]"
              class="required"
              mode="hexa"
            ></v-color-picker>
      </div>
      <div class="col-auto align-self-center">
        <div ref="icon" style="width: 50px;" class="svg-icon"></div>
      </div>

      <div class="col-auto align-self-center">
        <v-btn color="primary" @click="saveIconHandler" :disabled="!file">{{
          $t("globals.save")
        }}</v-btn>
      </div>
    </div>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data: () => ({
    selectedIcon: undefined,
    useThemeSettings: false,
    file: undefined,
    color: "#000000C5",
    svg:""
  }),
  computed: {
    ...mapGetters("common", { selectedPlan: "plan", settings: "settings" }),
  },
  props: {
    icon: Object,
  },
  watch: {
    useThemeSettings: {
      immediate: true,
      handler() {
        if (this.selectedIcon) {
          this.getSvg(this.$refs.icon.innerHTML);
        }
      },
    },
    color: {
      immediate: true,
      handler() {
        if (this.selectedIcon) {
          this.getSvg(this.svg);
        }
      },
    },
  },
  methods: {
    ...mapActions("downloadCenter", ["saveIcon"]),

    async handleFileChange(event) {
      if (!event) {
        this.selectedIcon = "";
        return;
      }
      var reader = new FileReader();

      reader.readAsText(event);
      const xml = await new Promise((resolve, reject) => {
        reader.onload = function(event) {
          resolve(reader.result);
        };
      });
      this.getSvg(xml, true);
      this.svg = xml;
    },

    removeFill(root) {
      if (root.style.fill || root.hasAttribute("fill")) {
        root.setAttribute(
          "data-fill",
          root.style.fill || root.getAttribute("fill")
        );
        root.style.fill = "";
        root.removeAttribute("fill");
      }
      for (var c of root.children) {
        this.removeFill(c);
      }
    },

    restoreFill(root) {
      //console.log(root.style.fill)
      if (root.hasAttribute("data-fill")) {
        // console.log(root);
        root.style.fill = root.getAttribute("data-fill");
      }
      for (var c of root.children) {
        this.restoreFill(c);
      }
    },
    
    colorFill(root) {
      // console.log(root);
      //if (root.style.fill || root.hasAttribute("fill")) {
        //console.log(root, "yo!");
        // root.setAttribute(
        //   "data-fill",
        //   root.style.fill || root.getAttribute("fill")
        // );
        // root.style.fill = "";
        // root.removeAttribute("fill");
        root.style.fill = this.color;//root.getAttribute("data-fill");
      //}
      // for (var c of root.children) {
      //   this.colorFill(c);
      // }
    },

    getSvg(xml, changeIds) {
      var parser = new DOMParser();
      var svg = parser.parseFromString(xml, "image/svg+xml");
      const root = svg.documentElement;
      root.removeAttribute("width");
      root.removeAttribute("height");
      if (changeIds) this.removeIds(root);
      // if (this.useThemeSettings) {
      //   this.removeFill(root);
      // } else {
      //   this.restoreFill(root);
      // }
      // this.restoreFill(root);
      this.colorFill(root);
      this.selectedIcon = this.$refs.icon.innerHTML = root.outerHTML;
    },

    async saveIconHandler() {
      const res = await this.saveIcon({
        Svg: this.selectedIcon,
        PlanId: this.selectedPlan.Id,
      });
      this.file = undefined;
      this.$el.querySelector("input").type = "text";
      this.$el.querySelector("input").type = "file";
      this.$emit("update:icon", { Svg: this.selectedIcon, Id: res });
      this.selectedIcon = this.$refs.icon.innerHTML = "";
    },

    removeIds(root, ids) {
      if (!ids) {
        ids = {};
      }
      if (
        root.hasAttribute("id") &&
        ids[root.getAttribute("id")] === undefined
      ) {
        const newId = this.$helpers.uuidv4();
        ids[root.getAttribute("id")] = newId;
        root.setAttribute("id", newId);
        root.setAttribute("xlink:href", "#" + newId);
      }
      let fill = root.style.fill || root.getAttribute("fill");
      if (fill) {
        const res = fill.match(/url\(#([^\)]+)\)/);
        if (res && res.length > 1 && ids[res[1]] !== undefined) {
          fill = "url(#" + ids[res[1]] + ")";
        }
        root.removeAttribute("fill");
        root.style.fill = fill;
      }
      for (var c of root.children) {
        this.removeIds(c, ids);
      }
    },
    
  },
};
</script>
<style></style>
